import React, { useEffect, useState } from 'react'
import { Compass, Ship, ArrowRight, PawPrint } from 'lucide-react';
import { Swiper, SwiperSlide } from "swiper/react";
import { Pagination, Autoplay, Navigation } from "swiper/modules";

import "swiper/css";
import "swiper/css/pagination";
import Footer from '../Components/Footer';
import Header from '../Components/Header';
import { Sun, Award, UserCheck, Wind } from 'lucide-react';
import {  Maximize,  Heart, Info } from "lucide-react";
import {  Bed,  MapPin, Anchor, Star } from "lucide-react";
import { ShieldCheck, HelpCircle,  CheckCircle2, AlertCircle } from 'lucide-react';
// import {    Sunset } from 'lucide-react';
import {    Shield } from 'lucide-react';
import { ChevronLeft, ChevronRight, Users } from 'lucide-react';
import FAQSection from '../Components/FAQSection';
import IndiaBoatsTopBar from '../Components/IndiaBoatsTopBar';
import PremiumNavbar from '../Components/PremiumNavbar';
import { useNavigate } from 'react-router-dom';
import { getMainImageUrl } from '../utils/fleetCardMedia';
import { getYachtDetailsPath } from '../utils/fleetCardSlug';
import SEO from '../Components/SEO';
import FleetCardSkeleton from '../Components/FleetCardSkeleton';
import { SEO_DATA } from '../config/seoData';

const pycFaqs = [
  {
    question: "What types of private yachts can I book in Mumbai?",
    answer: "You can explore private yacht charter options in Mumbai across categories such as sail boats, compact yachts, mid size yachts, premium yachts and bigger sail yachts."
  },
  {
    question: "How do I choose the right yacht category?",
    answer: "The right yacht depends on your group size, occasion, comfort preference and the type of private sea experience you want. Indiaboats can help recommend the best option."
  },
  {
    question: "Are sail boats and yachts both available for private charter?",
    answer: "Yes. Indiaboats offers both sail boats and private yachts in Mumbai for guests looking for different styles of on-water experience."
  },
  {
    question: "Is a compact yacht suitable for couples and small families?",
    answer: "Yes. Compact yachts are ideal for couples, small families and close groups looking for a private and comfortable yacht experience."
  },
  {
    question: "What is the benefit of choosing a premium yacht?",
    answer: "Premium yachts offer more space, stronger comfort, better onboard experience and a more elevated private yacht charter feel."
  },
  {
    question: "Can I book a private yacht for a birthday or anniversary?",
    answer: "Yes. Private yacht charters in Mumbai are a popular choice for birthdays, anniversaries and intimate celebrations."
  },
  {
    question: "Is a private yacht charter in Mumbai safe?",
    answer: "Yes. Indiaboats places strong emphasis on trained crew, guest support and responsible operations."
  },
  {
    question: "How do I enquire for a private yacht charter in Mumbai?",
    answer: "You can contact Indiaboats through the enquiry form or WhatsApp with your date, guest count and occasion."
  }
];

 const mumbaiCategories = [
  {
    id: "01",
    title: "Classic Windward Sailer",
    category: "Sail Boats",
    capacity: "Up to 6 Guests",
    dimensions: "18 to 24 feet",
    cabins: "-NA-",
    washroom: "-NA-",
    goodFor: "Couples",
    desc: "Elegant private sailing experiences for guests who enjoy open-water charm, relaxed cruising and a more authentic sailing feel.",
    imgUrl: "assets/img/pyc1.JPG",
    type: "Pure Sailing Experience"
  },
  {
    id: "02",
    title: "Sunset Private Yacht Charter",
    category: "Compact Yachts",
    capacity: "Up to 6 Guests",
    dimensions: "18 to 24 feet",
    cabins: "1 Cabin",
    washroom: "1 Washroom",
    goodFor: "Small Group",
    desc: "A compact private yacht charter in Mumbai ideal for couples, families and small groups looking for comfort, privacy and a memorable sea experience.",
    imgUrl: "assets/img/pyc2.JPG",
    type: "Intimate and private"
  },
  {
    id: "03",
    title: "Luxury Family Yacht Experience",
    category: "Mid Size Yachts",
    capacity: "Up to 8 Guests",
    dimensions: "25 to 30 feet",
    cabins: "1 Cabin",
    washroom: "1 Washroom",
    goodFor: "Mid Size Group",
    desc: "A mid size yacht rental in Mumbai designed for family outings, private leisure and premium moments on the water.",
    imgUrl: "assets/img/pyc3.JPG",
    type: "Balanced space and comfort"
  },
  {
    id: "04",
    title: "Premium Private Yacht Cruise",
    category: "Premium Yachts",
    capacity: "Up to 12 Guests",
    dimensions: "30 to 38 feet",
    cabins: "2 Cabins",
    washroom: "1 Washroom",
    goodFor: "Bigger Size Group",
    desc: "A premium private yacht charter in Mumbai for guests looking for a more luxurious, spacious and exclusive sea experience.",
    imgUrl: "assets/img/pyc4.JPG",
    type: "Higher luxury and comfort"
  },
  {
    id: "05",
    title: "Grand Horizon Sailing Vessel",
    category: "Bigger Sail Yachts",
    capacity: "Up to 15 Guests",
    dimensions: "35 to 45 feet",
    cabins: "2 Cabins",
    washroom: "1 Washroom",
    goodFor: "Bigger Size Group",
    desc: "A distinctive sailing experience with more space and stronger premium appeal for memorable private charters on the water.",
    imgUrl: "assets/img/pyc2.JPG",
    type: "Spacious premium sailing"
  }
];

const goaCategories = [
  {
    id: "g01",
    title: "Goan Breeze Catamaran",
    category: "Catamarans",
    capacity: "Up to 15 Guests",
    dimensions: "40 to 45 feet",
    cabins: "2 Cabins",
    washroom: "2 Washrooms",
    goodFor: "Island Parties",
    desc: "Perfect for Mandovi River cruising and island parties. Features expansive trampolines up front for sunbathing.",
    imgUrl: "assets/img/pyc1.JPG",
    type: "Ultra-Stable Twin Hull"
  },
  {
    id: "g02",
    title: "Mandovi Luxury Cruiser",
    category: "Speed Yachts",
    capacity: "Up to 8 Guests",
    dimensions: "28 to 38 feet",
    cabins: "1 Cabin",
    washroom: "1 Washroom",
    goodFor: "Fast Transfers",
    desc: "A rapid luxury cruiser designed to skip along the Goan coastline toward isolated island keys in total privacy.",
    imgUrl: "assets/img/pyc2.JPG",
    type: "Fast & Agile Luxury Format"
  },
  {
    id: "g03",
    title: "Panaji Elite Double Decker",
    category: "Party Yachts",
    capacity: "Up to 25 Guests",
    dimensions: "60 to 75 feet",
    cabins: "2 Cabins",
    washroom: "2 Washrooms",
    goodFor: "Birthdays, Corporates",
    desc: "Optimized for large celebrations, milestone sunsets, and corporate entertainment events on backwater channels.",
    imgUrl: "assets/img/pyc3.JPG",
    type: "Double-Deck Premium Space"
  },
  {
    id: "g04",
    title: "Arabian Crest Majesty",
    category: "Superyachts",
    capacity: "Up to 12 Guests",
    dimensions: "80+ feet",
    cabins: "4 Cabins",
    washroom: "4 Washrooms",
    goodFor: "Deep-Sea Voyaging",
    desc: "A premier luxury vessel built for long deep-sea adventures, dolphin watching, and high-end coastal excursions.",
    imgUrl: "assets/img/pyc4.JPG",
    type: "Ultimate Open-Ocean Luxury"
  },
  {
    id: "g05",
    title: "Vagator Premium Catamaran",
    category: "Luxury Catamarans",
    capacity: "Up to 18 Guests",
    dimensions: "48 feet",
    cabins: "3 Cabins",
    washroom: "3 Washrooms",
    goodFor: "Sunset Cruises",
    desc: "An exceptional luxury deck catamaran perfect for hosting breathtaking sunset cruises, family gatherings, and elite parties across Goa's scenic backwaters.",
    imgUrl: "assets/img/pyc2.JPG",
    type: "Spacious Deck Luxury Layout"
  }
];

const mumbaiCategories2 = [
  {
    id: "01",
    title: "Classic Windward Sailer",
    category: "Sail Boats",
    capacity: "Up to 6 Guests",
    dimensions: "18 to 24 feet",
    cabins: "-NA-",
    washroom: "-NA-",
    goodFor: "Couples",
    desc: "Elegant private sailing experiences for guests who enjoy open-water charm, relaxed cruising and a more authentic sailing feel.",
    imgUrl: "assets/img/pyc5.JPG",
    type: "Pure Sailing Experience"
  },
  {
    id: "02",
    title: "Sunset Private Yacht Charter",
    category: "Compact Yachts",
    capacity: "Up to 6 Guests",
    dimensions: "18 to 24 feet",
    cabins: "1 Cabin",
    washroom: "1 Washroom",
    goodFor: "Small Group",
    desc: "A compact private yacht charter in Mumbai ideal for couples, families and small groups looking for comfort, privacy and a memorable sea experience.",
    imgUrl: "assets/img/pyc6.JPG",
    type: "Intimate and private"
  },
  {
    id: "03",
    title: "Luxury Family Yacht Experience",
    category: "Mid Size Yachts",
    capacity: "Up to 8 Guests",
    dimensions: "25 to 30 feet",
    cabins: "1 Cabin",
    washroom: "1 Washroom",
    goodFor: "Mid Size Group",
    desc: "A mid size yacht rental in Mumbai designed for family outings, private leisure and premium moments on the water.",
    imgUrl: "assets/img/pyc7.JPG",
    type: "Balanced space and comfort"
  },
  {
    id: "04",
    title: "Premium Private Yacht Cruise",
    category: "Premium Yachts",
    capacity: "Up to 12 Guests",
    dimensions: "30 to 38 feet",
    cabins: "2 Cabins",
    washroom: "1 Washroom",
    goodFor: "Bigger Size Group",
    desc: "A premium private yacht charter in Mumbai for guests looking for a more luxurious, spacious and exclusive sea experience.",
    imgUrl: "assets/img/pyc8.JPG",
    type: "Higher luxury and comfort"
  },
  {
    id: "05",
    title: "Grand Horizon Sailing Vessel",
    category: "Bigger Sail Yachts",
    capacity: "Up to 15 Guests",
    dimensions: "35 to 45 feet",
    cabins: "2 Cabins",
    washroom: "1 Washroom",
    goodFor: "Bigger Size Group",
    desc: "A distinctive sailing experience with more space and stronger premium appeal for memorable private charters on the water.",
    imgUrl: "assets/img/pyc9.JPG",
    type: "Spacious premium sailing"
  }
];

const goaCategories2 = [
  {
    id: "g01",
    title: "Goan Breeze Catamaran",
    category: "Catamarans",
    capacity: "Up to 15 Guests",
    dimensions: "40 to 45 feet",
    cabins: "2 Cabins",
    washroom: "2 Washrooms",
    goodFor: "Island Parties",
    desc: "Perfect for Mandovi River cruising and island parties. Features expansive trampolines up front for sunbathing.",
    imgUrl: "assets/img/pyc1.JPG",
    type: "Ultra-Stable Twin Hull"
  },
  {
    id: "g02",
    title: "Mandovi Luxury Cruiser",
    category: "Speed Yachts",
    capacity: "Up to 8 Guests",
    dimensions: "28 to 38 feet",
    cabins: "1 Cabin",
    washroom: "1 Washroom",
    goodFor: "Fast Transfers",
    desc: "A rapid luxury cruiser designed to skip along the Goan coastline toward isolated island keys in total privacy.",
    imgUrl: "assets/img/pyc2.JPG",
    type: "Fast & Agile Luxury Format"
  },
  {
    id: "g03",
    title: "Panaji Elite Double Decker",
    category: "Party Yachts",
    capacity: "Up to 25 Guests",
    dimensions: "60 to 75 feet",
    cabins: "2 Cabins",
    washroom: "2 Washrooms",
    goodFor: "Birthdays, Corporates",
    desc: "Optimized for large celebrations, milestone sunsets, and corporate entertainment events on backwater channels.",
    imgUrl: "assets/img/pyc3.JPG",
    type: "Double-Deck Premium Space"
  },
  {
    id: "g04",
    title: "Arabian Crest Majesty",
    category: "Superyachts",
    capacity: "Up to 12 Guests",
    dimensions: "80+ feet",
    cabins: "4 Cabins",
    washroom: "4 Washrooms",
    goodFor: "Deep-Sea Voyaging",
    desc: "A premier luxury vessel built for long deep-sea adventures, dolphin watching, and high-end coastal excursions.",
    imgUrl: "assets/img/pyc4.JPG",
    type: "Ultimate Open-Ocean Luxury"
  },
  {
    id: "g05",
    title: "Vagator Premium Catamaran",
    category: "Luxury Catamarans",
    capacity: "Up to 18 Guests",
    dimensions: "48 feet",
    cabins: "3 Cabins",
    washroom: "3 Washrooms",
    goodFor: "Sunset Cruises",
    desc: "An exceptional luxury deck catamaran perfect for hosting breathtaking sunset cruises, family gatherings, and elite parties across Goa's scenic backwaters.",
    imgUrl: "assets/img/pyc6.JPG",
    type: "Spacious Deck Luxury Layout"
  }
];

const PrivateYachtCharters = () => {
  const navigate = useNavigate();
  const [activeTab, setActiveTab] = useState('mumbai');
  const [activeTab2, setActiveTab2] = useState('mumbai');
  const [luxuryMumbai, setLuxuryMumbai] = useState([]);
  const [luxuryGoa, setLuxuryGoa] = useState([]);
  const [exploreMumbai, setExploreMumbai] = useState([]);
  const [exploreGoa, setExploreGoa] = useState([]);
  const [fleetRevision, setFleetRevision] = useState(0);
  const [isFleetLoading, setIsFleetLoading] = useState(true);

  const getMediaUrl = (path) => {
    if (!path) return "";
    if (path.startsWith("http")) return path;
    if (path.startsWith("/uploads/")) return path;
    return path;
  };

  const hasText = (value) => Boolean(String(value || "").trim());
  const layoutText = (card) => {
    const cabins = String(card.cabins || "").trim();
    const washroom = String(card.washroom || "").trim();
  
    const layout = [];
  
    if (cabins) {
      layout.push(`Cabin ${cabins}`);
    }
  
    if (washroom) {
      layout.push(`Washroom ${washroom}`);
    }
  
    return layout.join(" / ");
  };

  useEffect(() => {
    fetch("/api/experiences/private-yacht-charter-mumbai-goa")
      .then((res) => (res.ok ? res.json() : null))
      .then((data) => {
        if (!data) return;
        if (data.luxuryMumbai) setLuxuryMumbai(data.luxuryMumbai);
        if (data.luxuryGoa) setLuxuryGoa(data.luxuryGoa);
        if (data.exploreMumbai) setExploreMumbai(data.exploreMumbai);
        if (data.exploreGoa) setExploreGoa(data.exploreGoa);
        setFleetRevision((value) => value + 1);
      })
      .catch((error) => console.error("Experience fetch error:", error))
      .finally(() => setIsFleetLoading(false));
  }, []);

  const activeFleet = activeTab === 'mumbai' ? luxuryMumbai : luxuryGoa;
  const activeFleet2 = activeTab2 === 'mumbai' ? exploreMumbai : exploreGoa;
    // Active filter state
  const [selectedYachtCategory, setSelectedYachtCategory] = useState('All');

  const comparisonSpecs = [
    {
      feature: "Best For",
      luxury: "Guests seeking a premium yacht experience",
      explore: "Guests looking for a more budget-conscious option",
      icon: <Award size={18} />
    },
    {
      feature: "Boat Feel",
      luxury: "More polished, premium and visually impressive",
      explore: "Simpler, older and more basic in overall feel",
      icon: <Anchor size={18} />
    },
    {
      feature: "Comfort",
      luxury: "Higher comfort and better onboard ambience",
      explore: "Functional comfort with less premium finish",
      icon: <ShieldCheck size={18} />
    },
    {
      feature: "Ideal Use",
      luxury: "Special occasions, celebrations and hosting",
      explore: "Casual outings where budget is the priority",
      icon: <HelpCircle size={18} />
    },
    {
      feature: "Our Recommendation",
      luxury: "Best choice for a more memorable experience",
      explore: "Best only for budget-led bookings",
      icon: <CheckCircle2 size={18} />
    }
  ];
  
  const yachtCategoriesData = [
    {
      category: "Sail Boats",
      size: "20 ft to 24 ft",
      amenities: "Basic open sail boats",
      capacity: "Up to 6 guests",
      goodFor: "Guests who want a simple sailing experience, scenic rides and a classic open-boat feel"
    },
    {
      category: "Compact Yachts",
      size: "Up to 24 ft",
      amenities: "Cabin included, usually no washroom or only a basic washroom",
      capacity: "Up to 6 guests",
      goodFor: "Couples and small groups looking for a compact private yacht experience"
    },
    {
      category: "Mid Size Yachts",
      size: "25 ft to 30 ft",
      amenities: "1 cabin, 1 washroom",
      capacity: "Up to 8 guests",
      goodFor: "Families, birthdays, anniversaries and guests wanting a better balance of comfort and privacy",
      highlighted: true // Highlighted choice
    },
    {
      category: "Premium Yachts",
      size: "30 ft to 40 ft",
      amenities: "2 to 3 cabins, 1 or 2 washrooms",
      capacity: "Up to 12 guests",
      goodFor: "Premium celebrations, family outings, client hosting and guests wanting a more spacious luxury experience",
      highlighted: true // Highlighted choice
    },
    {
      category: "Bigger Sail Yachts",
      size: "40+ ft",
      amenities: "2 to 3 cabins, 2 washrooms",
      capacity: "Up to 15 to 18 guests",
      goodFor: "Larger groups who want a sailing-style experience with more room, comfort and premium appeal"
    }
  ];

  // Unique variable name holding the curated private yacht options
  const privateYachtInventory = [
    {
      id: "yacht-01",
      title: "Classic Windward Sailer",
      category: "Sail Boats",
      size: "Authentic sailing feel",
      capacity: "Up to 6 Guests",
      desc: "Elegant private sailing experiences for guests who enjoy open-water charm, relaxed cruising and a more authentic sailing feel.",
      imgUrl: "assets/img/pyc1.JPG"
    },
    {
      id: "yacht-02",
      title: "Sunset Harborside Cruiser",
      category: "Compact Yachts",
      size: "Compact day cruiser",
      capacity: "Up to 8 Guests",
      desc: "Ideal for couples, small families and close groups looking for a private yacht rental in Mumbai with comfort and ease.",
      imgUrl: "https://images.unsplash.com/photo-1569263979104-865ab7cd8d13?auto=format&fit=crop&q=80&w=600"
    },
    {
      id: "yacht-03",
      title: "Versatile Family Outing Yacht",
      category: "Mid Size Yachts",
      size: "Spacious versatile platform",
      capacity: "Up to 12 Guests",
      desc: "A balanced option offering more space, comfort and versatility for private outings, family leisure and special moments.",
      imgUrl: "https://images.unsplash.com/photo-1540962351504-03099e0a754b?auto=format&fit=crop&q=80&w=600"
    },
    {
      id: "yacht-04",
      title: "Premium Private Yacht Cruise",
      category: "Premium Yachts",
      size: "Luxury leisure experience",
      capacity: "Up to 15 Guests",
      desc: "A premium private yacht charter in Mumbai for guests looking for a more luxurious, spacious and exclusive sea experience.",
      imgUrl: "https://images.unsplash.com/photo-1567899378494-47b22a28c6ad?auto=format&fit=crop&q=80&w=600"
    },
    {
      id: "yacht-05",
      title: "Grand Horizon Sailing Vessel",
      category: "Bigger Sail Yachts",
      size: "Premium ocean-going sailer",
      capacity: "Up to 20 Guests",
      desc: "A distinctive sailing experience with more space and stronger premium appeal for memorable private charters on the water.",
      imgUrl: "https://images.unsplash.com/photo-1500530855697-b586d89ba3ee?auto=format&fit=crop&q=80&w=600"
    }
  ];

  // Dynamically extract unique categories for filter tabs
  const filterTabsList = ['All', 'Sail Boats', 'Compact Yachts', 'Mid Size Yachts', 'Premium Yachts', 'Bigger Sail Yachts'];

  // Filter logic based on tab state
  const filteredYachtsList = selectedYachtCategory === 'All' 
    ? privateYachtInventory 
    : privateYachtInventory.filter(yacht => yacht.category === selectedYachtCategory);


     // Active state to track the highlighted category
  const [activeCategoryIndex, setActiveCategoryIndex] = useState(0);

  // Unique variable name for the updated explore categories data
  const exploreYachtSegments = [
    {
      id: "01",
      title: "Classic Windward Sailer",
      category: "Sail Boats",
      size: "Authentic sailing feel",
      capacity: "Up to 6 Guests",
      desc: "Elegant private sailing experiences for guests who enjoy open-water charm, relaxed cruising and a more authentic sailing feel.",
      imgUrl: "https://images.unsplash.com/photo-1505044157772-6ae174669140?auto=format&fit=crop&q=80&w=1000",
      icon: <Wind size={20} />,
      amenities: ["Classic Rigging", "Open Deck Lounge", "Authentic Sea Breeze"]
    },
    {
      id: "02",
      title: "Sunset Harborside Cruiser",
      category: "Compact Yachts",
      size: "Compact day cruiser",
      capacity: "Up to 8 Guests",
      desc: "Ideal for couples, small families and close groups looking for a private yacht rental in Mumbai with comfort and ease.",
      imgUrl: "https://images.unsplash.com/photo-1569263979104-865ab7cd8d13?auto=format&fit=crop&q=80&w=1000",
      icon: <Ship size={20} />,
      amenities: ["Sunset Saloon", "Couples Daybed", "Express Cruising"]
    },
    {
      id: "03",
      title: "Luxury Family Yacht Experience",
      category: "Mid Size Yachts",
      size: "Spacious and private format",
      capacity: "Up to 12 Guests",
      desc: "A mid size yacht rental in Mumbai designed for family outings, private leisure and premium moments on the water.",
      imgUrl: "https://images.unsplash.com/photo-1540962351504-03099e0a754b?auto=format&fit=crop&q=80&w=1000",
      icon: <Users size={20} />,
      amenities: ["Spacious Flybridge", "Multi-zone Audio", "Leisure Swim Platform"]
    },
    {
      id: "04",
      title: "Premium Private Yacht Cruise",
      category: "Premium Yachts",
      size: "Luxury leisure experience",
      capacity: "Up to 15 Guests",
      desc: "A premium private yacht charter in Mumbai for guests looking for a more luxurious, spacious and exclusive sea experience.",
      imgUrl: "https://images.unsplash.com/photo-1567899378494-47b22a28c6ad?auto=format&fit=crop&q=80&w=1000",
      icon: <Award size={20} />,
      amenities: ["Master Suite Cabin", "Gourmet Galley", "Exclusive Crew Service"]
    },
    {
      id: "05",
      title: "Grand Horizon Sailing Vessel",
      category: "Bigger Sail Yachts",
      size: "Premium ocean-going sailer",
      capacity: "Up to 20 Guests",
      desc: "A distinctive sailing experience with more space and stronger premium appeal for memorable private charters on the water.",
      imgUrl: "https://images.unsplash.com/photo-1500530855697-b586d89ba3ee?auto=format&fit=crop&q=80&w=1000",
      icon: <Compass size={20} />,
      amenities: ["Expansive Teak Decks", "High-performance Rigging", "Grand Dining Lounge"]
    }
  ];



const premiumYachtCategories = [
    {
      id: "01",
      title: "Classic Windward Sailer",
      category: "Sail Boats",
      size: "Authentic sailing feel",
      capacity: "Up to 6 Guests",
      desc: "Elegant private sailing experiences for guests who enjoy open-water charm, relaxed cruising and a more authentic sailing feel.",
      imgUrl: "https://images.unsplash.com/photo-1505044157772-6ae174669140?auto=format&fit=crop&q=80&w=600",
      type: "Authentic Experience"
    },
    {
      id: "02",
      title: "Sunset Private Yacht Charter",
      category: "Compact Yachts",
      size: "Ideal for premium experiences",
      capacity: "Up to 10 Guests",
      desc: "A compact private yacht charter in Mumbai ideal for couples, families and small groups looking for comfort, privacy and a memorable sea experience.",
      imgUrl: "https://images.unsplash.com/photo-1569263979104-865ab7cd8d13?auto=format&fit=crop&q=80&w=600",
      type: "Intimate Cruise"
    },
    {
      id: "03",
      title: "Luxury Family Yacht Experience",
      category: "Mid Size Yachts",
      size: "Spacious and private format",
      capacity: "Up to 12 Guests",
      desc: "A mid size yacht rental in Mumbai designed for family outings, private leisure and premium moments on the water.",
      imgUrl: "https://images.unsplash.com/photo-1540962351504-03099e0a754b?auto=format&fit=crop&q=80&w=600",
      type: "Versatile Comfort"
    },
    {
      id: "04",
      title: "Premium Private Yacht Cruise",
      category: "Premium Yachts",
      size: "Luxury leisure experience",
      capacity: "Up to 15 Guests",
      desc: "A premium private yacht charter in Mumbai for guests looking for a more luxurious, spacious and exclusive sea experience.",
      imgUrl: "https://images.unsplash.com/photo-1567899378494-47b22a28c6ad?auto=format&fit=crop&q=80&w=600",
      type: "Signature Luxury"
    },
    {
      id: "05",
      title: "Grand Horizon Sailing Vessel",
      category: "Bigger Sail Yachts",
      size: "Premium ocean-going sailer",
      capacity: "Up to 20 Guests",
      desc: "A distinctive sailing experience with more space and stronger premium appeal for memorable private charters on the water.",
      imgUrl: "https://images.unsplash.com/photo-1500530855697-b586d89ba3ee?auto=format&fit=crop&q=80&w=600",
      type: "Grand Voyage"
    }
  ];

  
  return (

    
    <>
        <SEO {...SEO_DATA.privateYachtCharter} />
        <IndiaBoatsTopBar/>
      <PremiumNavbar/>

 {/* <section className="idx-section" id="destination-sec">


          <div className="idx-video-container" style={{ backgroundImage: `url('assets/img/pyc7.jpg')` }}>
            
            <div className="idx-overlay" />
          </div>

          <div className="idx-container">
            <div className="idx-header">
           <h1 className="idx-title" style={{ color: '#fff',textAlign: 'center' }}>
               Private Yacht Charters
              </h1>
              <section className="idx-pillar-wrapper1">
                <div className="container">
                 </div>
              </section>
  </div>

          
          </div>


        </section> */}
          <div className="ib-page-wrapper">
             <div className="aeb-page-section-one">   
      
    

   <section className="lyc-main-section">
      <div className="lyc-container lyc-section-container">
        
        {/* Navigation Tab Header Row */}
        <div className="lyc-header-navigation-block">
          <h1 className="idx-title" style={{ color: '#113d48',textAlign: 'center' }}>
               Private Yacht Charters
              </h1>
         
          <div className="lyc-tabs-wrapper">
            
            <button 
              className={`lyc-tab-btn ${activeTab === 'mumbai' ? 'active' : ''}`}
              onClick={() => setActiveTab('mumbai')}
            >
              <MapPin size={14} />
              <span>Mumbai</span>
            </button>
            <button 
              className={`lyc-tab-btn ${activeTab === 'goa' ? 'active' : ''}`}
              onClick={() => setActiveTab('goa')}
            >
              <MapPin size={14} />
              <span>Goa </span>
            </button>
          </div>
         <div className="epyo-badge-row">
            <Anchor size={14} className="epyo-badge-icon" />
            <span className="epyo-pre-title">Luxury Fleet</span>
          </div>
        </div>

        {/* Swiper Slider Component */}
        <div className="lyc-swiper-wrapper" style={{ position: 'relative' }}>
      {isFleetLoading ? (
        <FleetCardSkeleton />
      ) : (
      <>
      <Swiper
        modules={[Autoplay, Navigation]}
        spaceBetween={20}
        slidesPerView={4}
        loop={activeFleet.length > 4}
        autoplay={{
          delay: 5000,
          disableOnInteraction: false,
        }}
        navigation={{
          prevEl: ".lyc-swiper-prev",
          nextEl: ".lyc-swiper-next",
        }}
        breakpoints={{
          320: { slidesPerView: 1.25 },
          576: { slidesPerView: 2 },
          992: { slidesPerView: 3 },
          1200: { slidesPerView: 4 },
        }}
        className="lyc-swiper-instance"
        style={{ padding: '10px 10px' }}
        key={`luxury-${activeTab}-${fleetRevision}-${activeFleet.length}`}
      >
        {activeFleet.map((category) => (
          <SwiperSlide key={category._id || category.id}>
            <div className="lyc-card-v2">
              <div className="lyc-card-top-accent"></div>

              {/* Vertical Image Wrapper */}
              <div className="lyc-image-wrapper-v2">
                <img
                  src={getMediaUrl(getMainImageUrl(category))}
                  alt={category.title}
                  className="lyc-card-img-v2"
                />
                <div className="lyc-img-overlay"></div>
              </div>

              {/* Content Area */}
              <div className="lyc-card-content-v2">
                <div className="lyc-card-header">
                  <h3 className="lyc-card-title-v2">{category.title || category.category}</h3>
                  <span className="lyc-card-subtitle-tag">{category.type}</span>
                </div>

                {/* Expanded Specifications List */}
                <div className="lyc-card-specs-v2">
                  {hasText(category.desc) && (
                    <p className="lyc-card-desc">{category.desc}</p>
                  )}
                  {hasText(category.capacity) && (
                    <div className="lyc-spec-row-v2">
                      <Users size={12} className="lyc-spec-icon-v2" />
                      <span className="lyc-spec-label">Guests:</span>
                      <span className="lyc-spec-val">{category.capacity}</span>
                    </div>
                  )}

                  {hasText(category.dimensions) && (
                    <div className="lyc-spec-row-v2">
                      <Maximize size={12} className="lyc-spec-icon-v2" />
                      <span className="lyc-spec-label">Size:</span>
                      <span className="lyc-spec-val">{category.dimensions}</span>
                    </div>
                  )}

                  {layoutText(category) && (
                    <div className="lyc-spec-row-v2">
                      <Compass size={12} className="lyc-spec-icon-v2" />
                      <span className="lyc-spec-label">Layout:</span>
                      <span className="lyc-spec-val">{layoutText(category)}</span>
                    </div>
                  )}

                  {hasText(category.goodFor) && (
                    <div className="lyc-spec-row-v2">
                      <Heart size={12} className="lyc-spec-icon-v2" />
                      <span className="lyc-spec-label">Good For:</span>
                      <span className="lyc-spec-val">{category.goodFor}</span>
                    </div>
                  )}

                  {category.petFriendly && (
                    <div className="lyc-spec-row-v2" style={{ marginLeft: '6px' }}>
                      <PawPrint size={14} className="epyo-metric-icon" />
                      <span className="epyo-metric-text">Pet Friendly</span>
                    </div>
                  )}
                </div>

                {/* Sleek Premium Button */}
                <div className="lyc-card-footer-v2">
                  <button
                    type="button"
                    className="lyc-sleek-btn"
                    onClick={() => {
                      if (category._id) {
                        navigate(getYachtDetailsPath(category));
                      }
                    }}
                  >
                    <span className="lyc-btn-text">Book Now</span>
                    <span className="lyc-btn-icon-wrap">
                      <ChevronRight size={16} className="lyc-arrow-icon" />
                    </span>
                  </button>
                </div>
              </div>
            </div>
          </SwiperSlide>
        ))}
      </Swiper>

      {/* Navigation Buttons */}
      <button type="button" className="lyc-swiper-prev" aria-label="Previous Slide">
        <ChevronLeft size={20} />
      </button>
      <button type="button" className="lyc-swiper-next" aria-label="Next Slide">
        <ChevronRight size={20} />
      </button>
      </>
      )}
    </div>

      </div>
    </section>
     
      </div>


        <section className="lyc-main-section" id='explore_lyc_section'>
      <div className="lyc-container lyc-section-container">
        
        {/* Navigation Tab Header Row */}
        <div className="lyc-header-navigation-block">
          
          <div className="lyc-tabs-wrapper">
            <button 
              className={`lyc-tab-btn ${activeTab2 === 'mumbai' ? 'active' : ''}`}
              onClick={() => setActiveTab2('mumbai')}
            >
              <MapPin size={14} />
              <span>Mumbai</span>
            </button>
            <button 
              className={`lyc-tab-btn ${activeTab2 === 'goa' ? 'active' : ''}`}
              onClick={() => setActiveTab2('goa')}
            >
              <MapPin size={14} />
              <span>Goa </span>
            </button>
          </div>
          <div className="epyo-badge-row">
            <Anchor size={14} className="epyo-badge-icon" />
            <span className="epyo-pre-title">Explore Fleet</span>
          </div>
        </div>

        {/* Swiper Slider Component */}
        <div className="lyc-swiper-wrapper" style={{ position: 'relative' }}>
      {isFleetLoading ? (
        <FleetCardSkeleton />
      ) : (
      <>
      <Swiper
        modules={[Autoplay, Navigation]}
        spaceBetween={20}
        slidesPerView={4}
        loop={activeFleet2.length > 4}
        autoplay={{
          delay: 5000,
          disableOnInteraction: false,
        }}
        navigation={{
          prevEl: ".lyc-swiper-prev-explore",
          nextEl: ".lyc-swiper-next-explore",
        }}
        breakpoints={{
          320: { slidesPerView: 1.25 },
          576: { slidesPerView: 2 },
          992: { slidesPerView: 3 },
          1200: { slidesPerView: 4 },
        }}
        className="lyc-swiper-instance"
        style={{ padding: '10px 10px' }}
        key={`explore-${activeTab2}-${fleetRevision}-${activeFleet2.length}`}
      >
        {activeFleet2.map((category) => (
          <SwiperSlide key={category._id || category.id}>
            <div className="lyc-card-v2">
              <div className="lyc-card-top-accent"></div>

              {/* Vertical Image Wrapper */}
              <div className="lyc-image-wrapper-v2">
                <img
                  src={getMediaUrl(getMainImageUrl(category))}
                  alt={category.title}
                  className="lyc-card-img-v2"
                />
                <div className="lyc-img-overlay"></div>
              </div>

              {/* Content Area */}
              <div className="lyc-card-content-v2">
                <div className="lyc-card-header">
                  <h3 className="lyc-card-title-v2">{category.title || category.category}</h3>
                  <span className="lyc-card-subtitle-tag">{category.type}</span>
                </div>

                {/* Expanded Specifications List */}
                <div className="lyc-card-specs-v2">
                  {hasText(category.capacity) && (
                    <div className="lyc-spec-row-v2">
                      <Users size={12} className="lyc-spec-icon-v2" />
                      <span className="lyc-spec-label">Guests:</span>
                      <span className="lyc-spec-val">{category.capacity}</span>
                    </div>
                  )}

                  {hasText(category.dimensions) && (
                    <div className="lyc-spec-row-v2">
                      <Maximize size={12} className="lyc-spec-icon-v2" />
                      <span className="lyc-spec-label">Size:</span>
                      <span className="lyc-spec-val">{category.dimensions}</span>
                    </div>
                  )}

                  {layoutText(category) && (
                    <div className="lyc-spec-row-v2">
                      <Compass size={12} className="lyc-spec-icon-v2" />
                      <span className="lyc-spec-label">Layout:</span>
                      <span className="lyc-spec-val">{layoutText(category)}</span>
                    </div>
                  )}

                  {hasText(category.goodFor) && (
                    <div className="lyc-spec-row-v2">
                      <Heart size={12} className="lyc-spec-icon-v2" />
                      <span className="lyc-spec-label">Good For:</span>
                      <span className="lyc-spec-val">{category.goodFor}</span>
                    </div>
                  )}

                  {category.petFriendly && (
                    <div className="lyc-spec-row-v2" style={{ marginLeft: '6px' }}>
                      <PawPrint size={14} className="epyo-metric-icon" />
                      <span className="epyo-metric-text">Pet Friendly</span>
                    </div>
                  )}
                </div>

                {/* Sleek Premium Button */}
                <div className="lyc-card-footer-v2">
                  <button
                    type="button"
                    className="lyc-sleek-btn"
                    onClick={() => {
                      if (category._id) {
                        navigate(getYachtDetailsPath(category));
                      }
                    }}
                  >
                    <span className="lyc-btn-text">Book Now</span>
                    <span className="lyc-btn-icon-wrap">
                      <ChevronRight size={16} className="lyc-arrow-icon" />
                    </span>
                  </button>
                </div>
              </div>
            </div>
          </SwiperSlide>
        ))}
      </Swiper>

      {/* Unique Navigation Buttons for the Explore Slider */}
      <button type="button" className="lyc-swiper-prev-explore" aria-label="Previous Slide">
        <ChevronLeft size={20} />
      </button>
      <button type="button" className="lyc-swiper-next-explore" aria-label="Next Slide">
        <ChevronRight size={20} />
      </button>
      </>
      )}
    </div>

      </div>
    </section>

    
<section className="ycf-main-section">
      <div className="ycf-container">
        
        {/* Header Block Section */}
        <div className="ycf-header-block">
         
          
          <h2 className="ycf-section-title">
            How to Choose the Right Yacht <br /> <span className="ycf-light-text">for Your Experience</span>
          </h2>
          
          <div className="ycf-intro-wrapper">
            <p className="ycf-intro-text">
              Choose the fleet that matches your expectation. Our Luxury Fleet is ideal for guests who want a more polished, premium and memorable experience, while Explore Fleet is better suited for more budget-led bookings.
            </p>
          </div>
          
          
        </div>

        { }
        <div className="ycf-comparison-matrix">
          
          {/* Header row for Desktop Matrix */}
          <div className="ycf-matrix-header-row">
            <div className="ycf-col-label ycf-col-feature">Key Features</div>
            
            {/* Luxury Fleet Column Label (Primary Highlight Removed) */}
            <div className="ycf-col-label ycf-col-luxury">
              <h3 className="ycf-fleet-name">Luxury Fleet</h3>
              <p className="ycf-fleet-tagline">Polished & Memorable</p>
            </div>
            
            {/* Explore Fleet Column Label */}
            <div className="ycf-col-label ycf-col-explore">
              <h3 className="ycf-fleet-name">Explore Fleet</h3>
              <p className="ycf-fleet-tagline">Budget-Conscious Choice</p>
            </div>
          </div>

          {/* Matrix Rows */}
          <div className="ycf-matrix-body">
            {comparisonSpecs.map((item, index) => (
              <div className="ycf-matrix-row" key={index}>
                {/* Feature Description */}
                <div className="ycf-cell ycf-cell-feature">
                  <div className="ycf-feature-header">
                    <span className="ycf-feature-icon">{item.icon}</span>
                    <span className="ycf-feature-title">{item.feature}</span>
                  </div>
                </div>

                {/* Luxury Fleet Specification Cell (No extra highlighting) */}
                <div className="ycf-cell ycf-cell-luxury">
                  <span className="ycf-mobile-only-header">Luxury Fleet</span>
                  <p className="ycf-cell-text">{item.luxury}</p>
                </div>

                {/* Explore Fleet Specification Cell */}
                <div className="ycf-cell ycf-cell-explore">
                  <span className="ycf-mobile-only-header">Explore Fleet</span>
                  <p className="ycf-cell-text">{item.explore}</p>
                </div>
              </div>
            ))}
          </div>

        </div>

        { }
        {/* Bottom Advisory Callout Box */}
        <div className="ycf-recommendation-box">
          <div className="ycf-rec-icon-box">
            <AlertCircle size={24} />
          </div>
          <div className="ycf-rec-text-wrap">
            <h4 className="ycf-rec-title">Our Recommendation</h4>
            <p className="ycf-rec-paragraph">
              For special occasions and premium experiences, we recommend the <strong>Luxury Fleet</strong>. The <strong>Explore Fleet</strong> is better suited for guests prioritising budget over finish and onboard feel.
            </p>
          </div>
        </div>

      </div>
      </section>
  
<section className="ycc-main-section">
      <div className="ycc-container">
        
        {}
        <div className="ycc-header-block">
          
          
          <h2 className="ycc-section-title">
            How to Choose the <span className="ycc-light-text">Right Yacht Category</span>
          </h2>
          
          <div className="ycc-intro-wrapper">
            <p className="ycc-intro-text">
              Choose your yacht based on group size, onboard comfort and the type of experience you want. For most guests, <strong>Mid Size Yachts</strong> and <strong>Premium Yachts</strong> offer the best mix of comfort, privacy and overall experience.
            </p>
          </div>
          
          
        </div>

        {}
        <div className="ycc-table-wrapper">
          <div className="ycc-table-grid">
            
            {/* Table Header Row */}
            <div className="ycc-header-row">
              <div className="ycc-header-cell">Category</div>
              <div className="ycc-header-cell">Size</div>
              <div className="ycc-header-cell">Cabins / Washrooms</div>
              <div className="ycc-header-cell">Guest Capacity</div>
              <div className="ycc-header-cell">Good For</div>
            </div>

            {/* Table Body Rows */}
            <div className="ycc-body-rows">
              {yachtCategoriesData.map((yacht, index) => (
                <div 
                  key={index} 
                  className={`ycc-row-item ${yacht.highlighted ? 'ycc-row-highlight' : ''}`}
                >
                  {/* Category with stacked text badge underneath */}
                  <div className="ycc-cell ycc-cell-category">
                    <span className="ycc-cell-accent-line"></span>
                    <Compass size={18} className="ycc-cell-icon" />
                    <div className="ycc-category-info-wrap">
                      <span className="ycc-category-name">{yacht.category}</span>
                      {yacht.highlighted && (
                        <span className="ycc-recommendation-tag">Recommended Choice</span>
                      )}
                    </div>
                  </div>

                  {/* Size */}
                  <div className="ycc-cell ycc-cell-size">
                    <span className="ycc-mobile-label"><Maximize size={12} /> Size</span>
                    <span className="ycc-value-text">{yacht.size}</span>
                  </div>

                  {/* Cabins / Washrooms */}
                  <div className="ycc-cell ycc-cell-amenities">
                    <span className="ycc-mobile-label"><Bed size={12} /> Cabins / Washrooms</span>
                    <span className="ycc-value-text">{yacht.amenities}</span>
                  </div>

                  {/* Capacity */}
                  <div className="ycc-cell ycc-cell-capacity">
                    <span className="ycc-mobile-label"><Users size={12} /> Guest Capacity</span>
                    <span className="ycc-value-text font-semibold">{yacht.capacity}</span>
                  </div>

                  {/* Good For */}
                  <div className="ycc-cell ycc-cell-good-for">
                    <span className="ycc-mobile-label"><Heart size={12} /> Good For</span>
                    <p className="ycc-value-desc">{yacht.goodFor}</p>
                  </div>
                </div>
              ))}
            </div>

          </div>
        </div>

        {}
        <div className="ycc-recommendation-banner">
          <div className="ycc-rec-icon-wrap">
            <Info size={24} />
          </div>
          <div className="ycc-rec-content">
            <h4 className="ycc-rec-title">Strategic Fleet Guidance</h4>
            <p className="ycc-rec-desc">
              If you want a well-balanced option for most private outings, choose a <strong>Mid Size Yacht</strong>. If you want a more spacious and premium experience, choose a <strong>Premium Yacht</strong>.
            </p>
          </div>
        </div>

      </div>
            </section>

    <section className="ib-luxury-feature-wrapper">
  <div className="ib-luxury-feature-container">
    <div className="ib-luxury-feature-main-content">
      <h2 className="ib-luxury-feature-headline">
        Why Choose Indiaboats for Private Yacht Charters
      </h2>
      <p>
        <span className="ib-luxury-feature-text-accent">Indiaboats</span> 
        offers private yacht charters in Mumbai across multiple yacht categories, making it easier for guests to choose the right experience based on comfort, style, group size and occasion. Whether you prefer a classic sail boat, a compact yacht for a couple outing, a mid size yacht for family time or a premium yacht for a more luxurious experience, our fleet is designed to suit different private charter needs.
      </p>
      <p>
        We help guests explore the right yacht category and booking format so each private yacht experience feels comfortable, well-managed and memorable.
      </p>
    </div>

    <div className="ib-luxury-feature-grid">
      {[
        { title: "Diverse Fleet", desc: "Private yacht charter options across multiple yacht categories", icon: <Ship size={24} /> },
        { title: "Tailored Options", desc: "Sail boats, compact yachts, mid size yachts and premium yachts", icon: <Anchor size={24} /> },
        { title: "Versatile Groups", desc: "Ideal for couples, families and small private groups", icon: <Users size={24} /> },
        { title: "Perfect Moments", desc: "Suitable for leisure, sunset outings and special moments", icon: <Sun size={24} /> },
        { title: "Expert Crew", desc: "Trained crew and service-first experience", icon: <UserCheck size={24} /> },
        { title: "Premium Quality", desc: "Premium private yacht rental in Mumbai", icon: <Star size={24} /> }
      ].map((item, index) => (
        <div key={index} className="ib-luxury-feature-card">
          <div className="ib-luxury-feature-icon-box">{item.icon}</div>
          <div className="ib-luxury-feature-card-content">
            <h4>{item.title}</h4>
            <p>{item.desc}</p>
          </div>
        </div>
      ))}
    </div>
  </div>
</section>

      

  <section className="pfUniqueMainSection">
  <div className="pfUniqueContainer">
    
    {/* Section Header */}
    <div className="pfUniqueHeader" style={{ marginBottom: '2rem' }}>
      <h2 className="pfUniqueHeading">
        Perfect For
      </h2>
    </div>

    {/* Main Content Grid */}
    <div className="pfUniqueGridWrapper">
      {[
        "Private yacht charter in Mumbai for couples",
        "Family private yacht outings",
        "Small group private cruises",
        "Sunset yacht experiences",
        // "Premium private sea outings",
        "Birthday and anniversary celebrations",
        "Romantic and leisure yacht experiences"
      ].map((item, index) => (
        <div className="pfUniqueCardBox" key={index}>
          <div className="pfUniqueCheckIcon">✓</div>
          <p className="pfUniqueCardText">{item}</p>
        </div>
      ))}
    </div>
  </div>
</section>



      

   <section className="wteUniqueMainSection">
  <div className="wteUniqueContainer">
    <div className="wteUniqueContentWrapper">
      <div className="wteUniqueLeftContent">
        <span className="wteUniqueMiniTitle">
          WHAT TO EXPECT
        </span>

        <h2 className="wteUniqueHeading">
          What to Expect with <span>Indiaboats</span>
        </h2>

        <p className="wteUniqueParagraph">
          Every private yacht charter in Mumbai can be chosen based on yacht category, group size and preferred experience. Whether you select a sail boat, compact yacht, mid size yacht, premium yacht or bigger sail yacht, Indiaboats helps you find an option that matches your comfort level, occasion and desired experience on the water.
        </p>
      </div>

      <div className="wteUniqueRightContent">
        {[
          "Private yacht charter",
          "Category-based yacht selection",
          "Professional crew",
          "Scenic sea experience",
          "Comfortable private setting",
          "Suitable for couples, families and close groups",
          "Booking assistance and coordination",
          "Safety briefing and support"
        ].map((item, index) => (
          <div className="wteUniqueListCard" key={index}>
            <div className="wteUniqueCheckCircle">✓</div>
            <p className="wteUniqueListText">{item}</p>
          </div>
        ))}
      </div>
    </div>
  </div>
</section>

     <section className="scUniqueMainSection">
      <div className="scUniqueContainer">
        <div className="scUniqueContentBox">
          <span className="scUniqueMiniTitle">
            SAFETY & COMFORT
          </span>

          <h2 className="scUniqueHeading">
            Safety, Comfort and <span>Service</span>
          </h2>

          <p className="scUniqueParagraph">
          At Indiaboats, safety is central to every private yacht charter experience. We place strong emphasis on trained crew, responsible operations, guest comfort and smooth coordination so every private yacht rental in Mumbai is both enjoyable and professionally managed.
          </p>
        </div>
      </div>
    </section>

    <FAQSection
  pageKey="private-yacht-charter-mumbai-goa"
  title="Frequently Asked Questions About Private Yacht Charters"
  faqData={pycFaqs}
/>

 {/* <section className="igxMainCtaSection">
      <div className="igxMainCtaContainer">
        <div className="igxGlassCardWrapper">

        

          <h2 className="igxMainHeading">
           Book Your <span>Private Yacht Charter</span> in Mumbai
          </h2>

          <p className="igxParagraphText">
           Browse sail boats, compact yachts, mid size yachts, premium yachts and bigger sail yachts to find the right private yacht charter in Mumbai for your next outing.
          </p>

          <div className="igxButtonFlex">

            <button className="igxPrimaryActionBtn">
              <span>Book a Private Yacht </span>
            </button>

            <button className="igxOutlineActionBtn">
              <span>Explore Private Yacht Charters</span>
            </button>

            <button className="igxWhatsappActionBtn">
              <span>Request a Quote</span>
            </button>

          </div>
        </div>
      </div>
    </section> */}

     {/* <section className="btfUniqueSection">
      <div className="btfUniqueContainer">

        <div className="btfUniqueFormCard">

          <div className="btfUniqueTopContent">
            <h2 className="btfUniqueHeading">
              Tell Us What You’re <span>Planning</span>
             
            </h2>

            <p className="btfUniqueParagraph">
              Share your preferred destination, group size and travel
              requirement and our team will help you plan the right
              private boat experience.
            </p>
          </div>

       <form className="btfUniqueFormWrapper">
  <div className="btfUniqueInputGrid">
    
    <div className="btfUniqueFieldBox">
      <label>Name</label>
      <input type="text" placeholder="Enter your name" />
    </div>

    <div className="btfUniqueFieldBox">
      <label>Mobile Number</label>
      <input type="tel" placeholder="Enter mobile number" />
    </div>

    <div className="btfUniqueFieldBox">
      <label>Email Address</label>
      <input type="email" placeholder="Enter email address" />
    </div>

    <div className="btfUniqueFieldBox">
      <label>Preferred Date</label>
      <input type="date" />
    </div>

    <div className="btfUniqueFieldBox">
      <label>Number of Guests</label>
      <input type="number" placeholder="Number of guests" />
    </div>

  <div className="btfUniqueFieldBox">
  <label>Occasion</label>
  <input type="text" placeholder="e.g. Birthday, Anniversary, Private Celebration" />
</div>

<div className="btfUniqueFieldBox">
  <label>Preferred Yacht Category</label>
  <select>
    <option value="">Select yacht category</option>
    <option value="sail-boat">Sail Boat</option>
    <option value="compact-yacht">Compact Yacht</option>
    <option value="mid-size-yacht">Mid-Size Yacht</option>
    <option value="premium-yacht">Premium Yacht</option>
    <option value="large-sail-yacht">Bigger Sail Yacht</option>
  </select>
</div>

  </div>

  <div className="btfUniqueFieldBox btfUniqueTextareaBox">
    <label>Requirement Details</label>
    <textarea
      rows="6"
      placeholder="Tell us more about your private party requirements..."
    ></textarea>
  </div>

  <button
    type="submit"
    className="btfUniqueSubmitButton"
  >
    <span>Request a Quote</span>
  </button>
</form>
        </div>
      </div>
    </section> */}

            </div>


<Footer/>
</>
  )
}

export default PrivateYachtCharters
